import { HttpService } from '@app/core/http/http.service';
import { Injectable } from '@angular/core';

import { CleanupInfoView } from "@app/shared/models/administration/cleanup/CleanupInfoView";
import { GlobalCleanupConfigurationInfoView } from "@app/shared/models/administration/cleanup/GlobalCleanupConfigurationInfoView";
import { CustomerCleanupConfigurationInfoView } from "@app/shared/models/administration/cleanup/CustomerCleanupConfigurationInfoView";
import { CleanupTaskView } from "@app/shared/models/administration/cleanup/CleanupTaskView";

import { default as constantsFile } from '@app/shared/constants.json';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";

@Injectable()
export class AdministrationCleanupService {

  private sApiCleanupInformation = '/api/cleanup';
  private sApiCleanupLogInformation = '/log';
  private sApiCleanupCountries = '/countries';

  constants: any = constantsFile.constants;

  constructor(private http: HttpService) { }

  public getCleanupData(): Observable<CleanupInfoView> {
    return this.http.get<CleanupInfoView>(this.sApiCleanupInformation)
      .pipe(
        map(
          (cleanupInfo: CleanupInfoView, index: number) => {
            return this.initData(cleanupInfo, (index + 1));
          }
        )
      );
  }

  public saveCleanupData(cleanupInfo: CleanupInfoView): Observable<string> {
    return this.http.post<string>(this.sApiCleanupInformation, cleanupInfo);
  }

  public changeStatusProcess(value: boolean){
    return this.http.put<string>(this.sApiCleanupInformation, value);
  }

  public getCleanupTasksLogData(): Observable<Array<CleanupTaskView>> {
    return this.http.get<Array<CleanupTaskView>>(this.sApiCleanupInformation + this.sApiCleanupLogInformation);
  }

  public getAllCountries(customerId: number): Observable<Array<string>> {
    return this.http.get<Array<string>>(this.sApiCleanupInformation + this.sApiCleanupCountries + "/" + customerId);
  }

  // #region PRIVATE METHODS

  private initData(cleanupInfo: CleanupInfoView, index: number): CleanupInfoView {
    if(cleanupInfo == null){
      cleanupInfo = new CleanupInfoView();
      cleanupInfo.globalCleanupConfigurationInfo = new GlobalCleanupConfigurationInfoView();
      cleanupInfo.globalCleanupConfigurationInfo.isProcessEnabled = false;
      cleanupInfo.globalCleanupConfigurationInfo.lastExecutionDate = undefined;
      cleanupInfo.customerCleanupConfigurations = new Array<CustomerCleanupConfigurationInfoView>();
    } else {
      cleanupInfo.customerCleanupConfigurations.map( (c: CustomerCleanupConfigurationInfoView, index: number) => c.id = index); //Needed for id component
      cleanupInfo.globalCleanupConfigurationInfo.timeExecution = new Date(cleanupInfo.globalCleanupConfigurationInfo.timeExecution);
    }
    return cleanupInfo;
  }
}
